export const configData = {
    // BASE_URL: "https://service.biny.co/" 
    // TODO надо сделать чтобы с env переменнами работал
    BASE_URL: process.env.REACT_APP_API_URL || "https://service.biny.co/"
}
